export default __webpack_public_path__ + "static/media/NotoSansKR-Thin.03e27898.woff2";